import {NgModule} from '@angular/core';
import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'test-page',
    templateUrl: './test.page.html',
    styleUrls: ['./test.page.scss']
})

export class TestPage implements OnInit {

    ngOnInit() {
    }

}
